import { api } from '@/api/client';
import type { CorrectionSnapshot, CorrectionVersionInfo } from './model';

export const correctionsApi = {
  list: (runId: string) => api.get<{ run_id: string; versions: CorrectionVersionInfo[] }>(`/api/runs/${encodeURIComponent(runId)}/corrections`),
  get: (runId: string, slug: string) => api.get<CorrectionSnapshot>(`/api/runs/${encodeURIComponent(runId)}/corrections/${encodeURIComponent(slug)}`),
  put: (runId: string, slug: string, snapshot: CorrectionSnapshot) =>
    api.put<{ version: CorrectionVersionInfo; snapshot: CorrectionSnapshot }>(`/api/runs/${encodeURIComponent(runId)}/corrections/${encodeURIComponent(slug)}`, snapshot),
  delete: (runId: string, slug: string) => api.del(`/api/runs/${encodeURIComponent(runId)}/corrections/${encodeURIComponent(slug)}`),
};
